import { render, staticRenderFns } from "./ChatLeftSidebar.vue?vue&type=template&id=b3a49aa6&scoped=true"
import script from "./ChatLeftSidebar.vue?vue&type=script&lang=js"
export * from "./ChatLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChatLeftSidebar.vue?vue&type=style&index=0&id=b3a49aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a49aa6",
  null
  
)

export default component.exports